import { reducer, on } from "ts-action";
import type { startseite } from "@progressive-development/politik-model";

import { loadAufmacher, loadVerzeichnisse } from "./startseite-actions.js";
import type { StartseiteVerzeichnisse } from "../service/startseite-service.js";

/**
 * Reducer der Startseite.
 *
 * Nur Ablegen, kein Zusammenrechnen: Die Seite zeigt, was der Export liefert.
 * Verzeichnisse und Aufmacher stehen getrennt, weil sie getrennt geladen
 * werden — ein Gebietswechsel tauscht nur den Aufmacher aus.
 */
export interface StartseiteState {
  /** undefined = noch nie geladen (die Blöcke rendern dann nicht). */
  verzeichnisse?: StartseiteVerzeichnisse;
  aufmacher?: startseite.AufmacherDokument;
  /** Für welches Gebiet der Aufmacher gilt — Bezirks-Slug oder "stadtweit". */
  aufmacherFuer?: string;
}

const initialState: StartseiteState = {};

export const startseiteReducer = reducer<StartseiteState>(
  initialState,
  on(loadVerzeichnisse.success, (state, { payload }) => ({
    ...state,
    verzeichnisse: payload,
  })),
  on(loadAufmacher.success, (state, { payload }) => ({
    ...state,
    aufmacher: payload.dokument,
    aufmacherFuer: payload.fuer,
  })),
);
